export default class MSEAdapter {

  static global(){
    if(typeof this._mse == "undefined"){
      this._mse = (window['MediaSource'] || window['WebKitMediaSource']);
      if(this._mse){
        this._mse.supported = true;
      }else{
        this._mse = this.nullObject();
      }
    }
    return this._mse;
  }

  static noop(){}

  static nullObject(){
    return {
      isTypeSupported: this.noop
    }
  }

  static isTypeSupported(){
    return this.global().isTypeSupported;
  }

  static isSupported(){
    return !!(this.global().supported);
  }
}
